module.exports = "/assets/cola-page/logo_1@2x.png?mz0n7lT";